module.exports = __webpack_public_path__ + "img/seo-content-collapsible-lincoln.b799a100.png";